// extracted by mini-css-extract-plugin
export default {"billIcon":"uFBjH8_ZCvB6DzVohbDK","placeHolderShimmer":"f9TJTxLcLtOwVvm6tZMK"};